import gql from 'graphql-tag';

import { AI_TEXT_SIZE } from 'src/data/generation';
import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendBlogPostBuilderContent,
  BackendMutationUpdateBlogPostBuilderContentArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateBlogPostBuilderContent(
    $projectId: ID!
    $draftId: ID
    $title: String!
    $titleScore: Int
    $introParagraph: String!
    $introManualKeywords: [String!]
    $introKeywordsUsage: JSON
    $introInstructions: String
    $introGenerationLength: BlogContentGenerationLengthEnum
  ) {
    updateBlogPostBuilderContent(
      projectId: $projectId
      draftId: $draftId
      title: $title
      titleScore: $titleScore
      introParagraph: $introParagraph
      introManualKeywords: $introManualKeywords
      introKeywordsUsage: $introKeywordsUsage
      introInstructions: $introInstructions
      introGenerationLength: $introGenerationLength
    ) {
      id
    }
  }
`;

type Variables = BackendMutationUpdateBlogPostBuilderContentArgs;
type Result = Pick<BackendBlogPostBuilderContent, 'id'>;

export const updateBlogPostBuilderContent = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...variables,
      introKeywordsUsage: stringifyIfPresent(variables.introKeywordsUsage),
      introGenerationLength: variables.introGenerationLength || AI_TEXT_SIZE.medium,
    },
  });

  return getSingleProp<Result>(result.data);
};
